export default class OrderNote {
  constructor (data) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new OrderNote(json);
  }
}
